import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import { Form } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../commons/formik/formikTextField";
import FormikActions from "../formik/formikActions";
import FormikForm from "../formik/formikForm";
import FormikSelect from "../formik/formikSelect";
import CustomDialog from "./customDialog";

const validation = Yup.object({
  artId: Yup.string().required("Campo obligatorio"),
  idPrestadorArt: Yup.number()
    .integer("Identificador inválido")
    .required("Campo obligatorio")
    .min(0, "Identificador inválido"),
});

const EditArtAdhesionDialog = ({
  adhesion,
  artsNotAdhered,
  open,
  handleClose,
  addingNewAdhesion,
  handleSubmit,
  loading,
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: loading
          ? { overflow: "hidden" }
          : undefined,
      }}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 160,
            overflow: "hidden",
          }}
        >
          <CircularProgress size={40} />
        </Box>
      ) : (
        <div>
          <DialogTitle>
            {addingNewAdhesion ? "Nueva adhesión" : "Editar adhesión"}
          </DialogTitle>
          <FormikForm
            initialValues={adhesion}
            validationSchema={validation}
            onSubmit={(values) => {
              handleSubmit(values, addingNewAdhesion);
            }}>
            <Form>

              <DialogContent>
                {addingNewAdhesion ? (
                  <FormikSelect name="artId" label="ART">
                    {artsNotAdhered &&
                      artsNotAdhered.map((art) => {
                        return (
                          <MenuItem key={art.id} value={art.id}>
                            {art.nombre}
                          </MenuItem>
                        );
                      })}
                  </FormikSelect>
                ) : (
                  <FormikSelect
                    name="nombre"
                    value={adhesion.nombre}
                    label="ART"
                    disabled>
                    <MenuItem value={adhesion.nombre}>
                      {adhesion.nombre}
                    </MenuItem>
                  </FormikSelect>
                )}
                <FormikTextField
                  margin="dense"
                  sx={{
                    marginTop: 5,
                  }}
                  name="idPrestadorArt"
                  label="Identificador"
                  type="number"
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <FormikActions handleCancel={handleClose} />
              </DialogActions>
            </Form>
          </FormikForm>
        </div>
      )}
    </CustomDialog>
  );
};

export default EditArtAdhesionDialog;
